export default {
	"empty": {},
	"languageName": 'English',
	"en": { text: 'English' },
	"ro": { text: 'Romanian' },
	"de": { text: 'German' },
	"hr": { text: 'Croatian' },

	"take-a-seat": { text: 'Take a seat' },
	"share-your-screen": { text: 'Share your screen' },
	"open-link": { text: 'Open link' },
	"change-scene": { text: 'Change scene' },
	"make-a-donation": { text: 'Make a donation' },
	"play-chess": { text: 'Play chess' },
	"shop": { text: 'Shop' },

	"take-seat-custom-message": { text: 'Are you sure that you want to take this seat?' },
	"share-location": { text: 'Share location' },
	"share-location-input": { placeholder: 'World URL' },
	"share-location-submit": { value: 'Copy URL' },
	"media-settings": { text: 'Settings' },
	"media-settings-submit": { value: 'apply settings' },

	"user-menu-status": { text: 'Status' },
	"user-mood-available": { text: 'Available' },
	"user-mood-away": { text: 'Away' },
	"user-mood-dnd": { text: 'Do not disturb' },
	"user-edit-profile": { text: 'Edit profile' },
	"user-profile-login": { text: 'Log in' },
	"user-profile-logout": { text: 'Logout' },
	"user-profile-edit-room": { text: 'Edit room', value: 'Edit room' },

	"avatar-upload-title": { text: 'Upload your photo' },
	"avatar-crop-title": { text: 'Crop your photo' },
	"avatar-upload-requirements": { text: '250x250 Min / 5 MB Max' },
	"upload-photo-button": { text: 'Upload Photo' },
	"save-button": { text: 'Save' },
	"cancel-button": { text: 'Cancel' },
	"avatar-upload-error-size": { text: 'Image file size must be less than 5MB' },
	"avatar-upload-error-type": { text: 'Please select a valid image file (JPEG, PNG, GIF)' },
	"avatar-upload-error-dimensions": { text: 'Image must be at least 250x250 pixels' },
	"avatar-upload-error-upload": { text: 'Upload failed. Please try again.' },
	"avatar-upload-error-process": { text: 'Failed to process image. Please try again.' },

	"tune-menu-device-settings": { text: 'Device settings' },
	"tune-menu-elements-visible": { text: 'Elements visible' },
	"tune-menu-ambient-music": { text: 'Ambient music' },
	"tune-menu-compass": { text: 'Compass' },
	"device-orientation-controller": { text: 'Device orientation controller' },
	"tune-menu-welcome-screen": { text: 'Welcome screen' },
	"tune-menu-exit-room": { text: 'Exit room' },
	"tune-menu-lock-location": { text: 'Lock location' },
	"tune-menu-help": { text: 'Help' },

	"leave-preview-text": { text: 'Leave preview' },
	"close-text": { text: 'Close' },
	"download-text": { text: 'Download' },
	"content-text": { text: 'Content' },
	"date-text": { text: 'Date' },
	"vrai-agent-talk-summary-title": { text: 'Conversation summary' },
	"room-chat-header-text": { text: 'Space chat' },
	"people-text": { text: 'People' },
	"scene-text-chat": { text: 'In this room' },
	"room-text": { text: 'Entire space' },
	"friends-text": { text: 'Friends' },
	"tour-text": { text: 'Tour' },
	"podium-text": { text: 'Tour Podium' },
	"invite-to-tour-text": { text: 'Invite To Tour' },
	"invite-to-podium-text": { text: "Tour Guests" },
	"invite-to-podium-text-user": { text: "Invite {user} to Podium" },
	"invite-as-tour-guest-text": { text: "Invite as tour guest" },
	"invite-to-podium-menu-text": { text: "Invite to podium" },
	"remove-from-podium-text": { text: "Remove from podium" },
	"remove-from-tour-text": { text: "Remove from tour" },
	"podium-invitation-sent-text": { text: "Podium invitation sent" },
	"is-inviting-you-to-podium": { text: "{user} is inviting you to Tours {name} podium" },
	"pending-invitation-text": { text: 'Not in tour' },
	"waiting-for-response-text": { text: "(waiting for response)" },
	"jump-to-scene-text": { text: 'Jump to their scene' },
	"invite-to-scene-text": { text: 'Invite to your scene' },
	"add-as-friend-text": { text: 'Add as friend' },
	"remove-from-friends-text": { text: 'Remove from friends' },
	"show-user-info-text": { text: 'Show user info' },
	"invite-tour-user-info-text": { text: 'Invite to tour' },
	"invite-tour-user-as-guest": { text: 'Invite guests' },
	"you-text": { text: 'You' },
	"chat-text": { text: 'Chat' },
	"type-msg-placeholder": { placeholder: 'Type message' },
	"send-text": { text: 'Send' },
	"invite-to-scene-title": { text: 'Invitation to join scene' },
	"invitation-message": { text: 'is inviting you to join' },
	"invitation-message-tour": { text: 'Invite to tour' },
	"join-scene-text": { text: 'Join scene' },
	"yes-text": { text: 'Yes' },
	"cancel-text": { text: 'Cancel', value: 'Cancel' },
	"delete-text": { text: 'Delete' },
	"save-text": { text: 'Save' },
	"save-value": { value: 'Save' },
	"access-room-text": { text: 'Enter room' },
	"microphone-text": { text: 'Microphone' },
	"camera-text": { text: 'Camera' },
	"sound-text": { text: 'Sound' },
	"join-room-text": { text: 'Join room' },
	"take-seat-text": { text: 'Take a seat' },
	"take-seat-value": { value: 'Take seat' },
	"preview-text": { text: 'Preview' },
	"publish-text": { text: 'Publish' },
	"view-mode-title": { title: 'Switch to view mode' },
	"nav-view-mode": { title: 'Switch to view mode', text: 'Go to view mode' },
	"exit-text": { text: 'Exit' },
	"join-as-guest-text": { text: 'Join as guest' },
	"edit-profile-guest-notice": { text: 'As guest you will have limited possibilities and features' },
	"edit-profile-text": { text: 'Edit profile' },
	"my-profile-text": { text: 'My profile' },
	"spaces-text": { text: 'Spaces' },
	"tours-text": { text: 'Tours' },
	"notifications-text": { text: 'Notifications' },
	"subscription-billing-text": { text: 'Subscription & Billing' },
	"username-text": { text: 'Username' },
	"avatar-image-text": { text: 'Avatar image' },
	"avatar-image-alt": { alt: 'Avatar image' },
	"image-alt": { alt: 'Avatar image' },
	"upload-avatar-text": { text: 'Upload avatar' },
	"no-account-q-text": { text: "Don't have an account?" },
	"login-text": { text: "Log in" },
	"register-text": { text: "Register" },
	"interests-text": { text: "Interests" },
	"video-call-text": { text: "Video call" },
	"send-msg-text": { text: "Send message" },
	"see-profile-text": { text: "See profile" },
	"dont-show-again-text": { text: "Don't show this again" },
	"stop-screen-share-text": { text: "Stop screen share" },
	"grid-view-text": { text: "Grid view" },
	"tour-mode-text": { text: "Tour mode" },
	"fullscreen-text": { text: "Fullscreen" },
	"page-mute-text": { text: "Mute page audio" },
	"page-unmute-text": { text: "Unmute page audio" },
	"mute-text": { text: "Mute" },
	"unmute-text": { text: "Unmute" },
	"turn-mic-on-text": { text: "Turn microphone on" },
	"turn-mic-off-text": { text: "Turn microphone off" },
	"has-muted-you": { text: "has muted you." },
	"has-unmuted-you": { text: "has unmuted you." },
	"turn-cam-on-text": { text: "Turn camera on" },
	"turn-cam-off-text": { text: "Turn camera off" },
	"stand-up-text": { text: "Stand up" },
	"confirmation-text": { text: "Confirmation" },
	"no-reason-text": { text: "no reason" },
	"open-game-text": { text: "Open game" },
	"game-over-text": { text: "Game over" },
	"win-game-text": { text: "win the game" },
	"drawn-position-text": { text: "drawn position" },
	"scene-text": { text: "scene" },
	"scenes-text": { text: "scenes" },
	"from-text": { text: "from" },
	"this-scene": { text: "this scene" },
	"these-scenes": { text: "these scenes" },
	"element-text": { text: "element" },
	"elements-text": { text: "elements" },
	"general-text": { text: "General" },
	"search-placeholder": { placeholder: "Search..." },
	"duplicate-text": { text: 'Duplicate' },
	"upload-scene-text": { text: 'Upload scene' },
	"room-name-text": { text: 'Space name' },
	"home-url-text": { text: 'Home URL' },
	"tour-mode-name-text": { text: 'Tour mode' },
	"disable-autorotate-name-text": { text: 'Disable autorotate' },
	"disable-postits-name-text": { text: 'Disable postits' },
	"disable-chat-name-text": { text: 'Disable chat' },
	"disable-user-list-name-text": { text: 'Disable user list' },
	"navigation-menu-name-text": { text: 'Navigation menu' },
	"navigation-menu-editor-title": { text: 'Navigation Editor' },
	"navigation-menu-active-label": { text: 'Navigation Active' },
	"navigation-menu-add-entry": { text: '+ Add Menu Entry' },
	"navigation-menu-entry-editor-title": { text: 'Menu entry' },
	"navigation-menu-entry-name-label": { text: 'Name' },
	"navigation-menu-entry-type-label": { text: 'Type' },
	"navigation-menu-entry-room-label": { text: 'Room' },
	"navigation-menu-entry-url-label": { text: 'URL' },
	"navigation-menu-entry-visible-label": { text: 'Visible in navigation' },
	"navigation-menu-type-room": { text: 'Room' },
	"navigation-menu-type-url": { text: 'URL' },
	"navigation-menu-room-missing": { text: 'Room missing' },
	"hide-language-selection-name-text": { text: 'Lock room language' },
	"publicly-available-text": { text: 'Publicly available' },
	"welcome-screen-text": { text: 'Welcome screen' },
	"edit-text": { text: 'Edit' },
	"room-thumbnail-text": { text: 'Space thumbnail' },
	"upload-image-text": { text: 'Upload image' },
	"upload-thumbnail-img-title": { title: 'Upload thumbnail image' },
	"delete-thumbnail-img-title": { title: 'Delete thumbnail image' },
	"room-logo-text": { text: 'Space logo' },
	"upload-logo-img-title": { title: 'Upload logo image' },
	"delete-logo-img-title": { title: 'Delete logo image' },
	"splash-image-text": { text: 'Splash image' },
	"upload-splash-img-title": { title: 'Upload splash image' },
	"delete-splash-img-title": { title: 'Delete splash image' },
	"room-desc-text": { text: 'Space description' },
	"description-placeholder": { placeholder: 'Description' },
	"room-coord-text": { text: 'Space coordinates' },
	"set-text": { text: 'Set' },
	"room-contributors-text": { text: 'My Contributed Spaces' },
	"scene-name-text": { text: 'Scene name' },
	"home-scene-text": { text: 'Home scene' },
	"set-home-text": { text: 'Set as home' },
	"set-as-home-scene-text": { text: 'This scene is set as the home scene.' },
	"lockable-text": { text: 'Lockable' },
	"allow-lock-scene-text": { text: 'Allow users to lock scene' },
	"public-stage-text": { text: 'Public stage' },
	"public-stage-tooltip": { text: 'Everyone can listen and see everyone' },
	"upload-text": { text: 'Upload' },
	"ambient-audio-volume-text": { text: 'Ambient audio volume' },
	"scene-image-text": { text: 'Scene image' },
	"upload-scene-image-title": { title: 'Upload scene image' },
	"select-text": { text: 'Select' },
	"update-text": { text: 'Update' },
	"set-entry-point-tooltip": { text: "Set the scene entry point to the actual view orientation" },
	"drag-scene-title": { title: "Drag scene to another position" },
	"edit-scene-name-title": { title: "Click to edit scene name" },
	"go-to-scene-text": { text: 'Go to scene' },
	"size-text": { text: "Size" },
	"rotateX-text": { text: "Rotate X" },
	"rotateY-text": { text: "Rotate Y" },
	"tooltip-text": { text: "Tooltip" },
	"hide-on-start-text": { text: "Hide on start" },
	"show-drag-corners-text": { text: "Show drag corners" },
	"prompt-transcript-modal-text": { text: "Prompt transcript modal" },
	"component-name-text": { text: "Name" },
	"info-settings-text": { text: "Information settings" },
	"object-settings-tab-settings": { text: "Settings" },
	"object-settings-tab-events": { text: "Events/Actions" },
	"object-events-placeholder": { text: "Configure events and actions for this object." },
	"object-events-click": { text: "Bind Event to Action" },
	"object-events-click-add": { text: "Add Event" },
	"object-events-add-action": { text: "Add action" },
	"object-events-bind-action": { text: "Bind Action to Event" },
	"action-show": { text: "Show" },
	"action-hide": { text: "Hide" },
	"action-show-plus": { text: "Show+" },
	"action-hide-plus": { text: "Hide+" },
	"event-click": { text: "Click" },
	"event-call-started": { text: "Call started" },
	"event-call-ended": { text: "Call ended" },
	"event-agent-changed": { text: "Agent changed" },
	"event-room-entered": { text: "Room entered" },
	"event-intro-animation-started": { text: "Intro animation started" },
	"event-intro-animation-ended": { text: "Intro animation ended" },
	"event-welcome-closed": { text: "Welcome closed" },
	"event-consent-declined": { text: "User declined consent dialogue" },
	"event-play-once": { text: "Play once" },
	"event-play-loop": { text: "Play loop" },
	"event-stopped-playing": { text: "Stopped playing" },
	"event-video-started-playing": { text: "Video started playing" },
	"event-raycast-enter": { text: "Camera/raycast enter" },
	"event-raycast-leave": { text: "Camera/raycast leave" },
	"scene-events-actions": { text: "Events/Actions" },
	"scene-event-source": { text: "Room" },
	"add-to-show-title": { text: "Add component to show" },
	"add-to-hide-title": { text: "Add component to hide" },
	"add-show-hide-trigger": { text: "Component to click" },
	"add-show-hide-event": { text: "Event" },
	"action-go-to-scene": { text: "Go to scene" },
	"action-start-call": { text: "Start call" },
	"action-end-call": { text: "End call" },
	"action-switch-agent": { text: "Switch to library agent" },
	"action-open-link": { text: "Open link" },
	"action-go-to-room": { text: "Go to room" },
	"action-play": { text: "Play" },
	"action-pause": { text: "Pause" },
	"action-play-once": { text: "Play once" },
	"action-play-loop": { text: "Play loop" },
	"action-stop-playing": { text: "Stop playing" },
	"action-open": { text: "Open" },
	"action-show-profile": { text: "Show profile" },
	"action-show-info": { text: "Show info" },
	"action-open-gallery": { text: "Open gallery" },
	"action-send-command": { text: "Send command" },
	"action-show-image": { text: "Show image" },
	"action-open-modal": { text: "Open modal" },
	"action-show-gallery": { text: "Show gallery" },
	"action-start-slideshow": { text: "Start slideshow" },
	"action-next-image": { text: "Next image" },
	"action-previous-image": { text: "Previous image" },
	"action-close-gallery": { text: "Close gallery" },
	"action-close-video": { text: "Close video" },
	"action-close-element": { text: "Close element" },
	"action-open-welcome": { text: "Open welcome" },
	"action-close-welcome": { text: "Close welcome" },
	"action-animate-camera-look-at": { text: "Animate camera look at" },
	"bind-action-create": { text: "Create" },
	"bind-action-modal-title": { text: "Bind Action to Event" },
	"bind-action-action": { text: "Action" },
	"bind-action-image-index": { text: "Image number" },
	"bind-action-image-n": { text: "Image" },
	"bind-action-component": { text: "Component" },
	"event-selector-group-rooms": { text: "Rooms" },
	"event-selector-group-components": { text: "Components" },
	"connect-event-to-action": { text: "Bind event to action" },
	"connect-event-trigger": { text: "Component" },
	"connect-event-target-component": { text: "Target component" },
	"connect-event-component": { text: "Component" },
	"connect-event-action": { text: "Action" },
	"connect-event-library-agent": { text: "Your library" },
	"connect-event-select-agent": { text: "Please select an AI agent from your library" },
	"vapi-library-load-failed": { text: "Could not load your AI agent library. Try again." },
	"product-list-text": { text: "Products list" },
	"is-calling-you-text": { text: "is calling you" },
	"requests-to-share-screen-text": { text: "requests to share screen" },
	"publish-leave-text": { text: "Publish & Leave" },
	"discard-leave-text": { text: "Discard & Leave" },

	"confirm-take-seat": { text: 'Are you sure that you want to take this seat?' },
	"invite-take-seat": { text: 'Seat invitation' },
	"confirm-title-leave-seat": { text: 'Leave Seat' },
	"confirm-leave-seat": { text: 'Would you like to get up from your seat?' },
	"confirm-leave-game": { text: 'Are you sure you want to quit the game?' },
	"confirm-locked-by": { text: 'This location is locked by' },
	"ask-for-unlock": { text: "want's to join room" },
	"confirm-want-to-knock": { text: 'Do you want to knock for entry?' },
	"confirm-leaving-without-publishing": { text: "You're leaving edit mode without publishing changes." },
	"confirm-remove-scene": { text: "Are you sure that you want to remove this scene?" },
	"confirm-remove-element": { text: "Are you sure that you want to remove this element?" },
	"confirm-remove-element-has-actions": { text: "This element has" },
	"confirm-remove-element-will-be-deleted": { text: "that will also be deleted" },
	"action-text": { text: "action" },
	"actions-text": { text: "actions" },
	"event-text": { text: "event" },
	"events-text": { text: "events" },
	"confirm-delete": { text: "Are you sure that you want to delete" },
	"delete-space-confirmation-title": { text: "Are you sure you want to delete this space?" },
	"delete-space-confirmation-subtitle": { text: "This action cannot be undone. All data in this space will be permanently lost." },
	"confirm-you-will-delete": { text: "You will also delete" },
	"confirm-duplicate": { text: "Are you sure that you want to duplicate" },
	"confirm-you-will-duplicate": { text: "You will also duplicate" },
	"confirm-remove": { text: "Are you sure that you want to remove" },
	"confirm-delete-world-thumbnail": { text: "Are you sure that you want to delete world's thumbnail image" },
	"confirm-remove-ambient-song": { text: "Are you sure that you want to remove this ambient song?" },
	"confirm-add-as-owner-1": { text: "Are you sure you want to add" },
	"confirm-add-as-owner-2": { text: "as owner?" },
	"confirm-already-calling-you-answer": { text: "is already calling you. Do you want to answer?" },
	"confirm-room-data-changed": { text: "Room data changed, would you like to reload?" },

	"error-language-support": { text: 'This language is not supported' },
	"error-take-seat": { text: 'Someone was faster than you. The seat is already taken by' },
	"error-user-data-not-found": { text: 'User data not found!' },
	"error-no-wp-account": { text: "doesn't have a bagless account!" },
	"error-camera-start": { text: "Failed to start camera/microphone or taken by another application." },
	"error-left-the": { text: "left the" },
	"error-user-declined-request": { text: "User declined request" },
	"error-please-login": { text: "Please log in or register." },
	"error-screen-occupied": { text: "Screen occupied!" },
	"error-screen-share-occupied": { text: "There is an active screenshare, please wait for this to end." },
	"error-screen-share-not-allowed": { text: "Sorry, you are not allowed to share on this screen." },
	"error-screen-share": { text: "Screen share not allowed" },
	"error-video-stream-not-ready": { text: "Video stream not ready yet. Try again in a few seconds!" },
	"error-calling-yourself": { text: "You were calling yourself..." },
	"error-call-friend-disconnected": { text: "Your call friend got disconnected" },
	"error-call-friend-offline": { text: "Your call friend is offline" },
	"error-call-friend-busy": { text: "Your call friend is busy" },
	"error-call-friend-in-tour": { text: "Your call friend is on a tour" },
	"error-call-already-in-progress": { text: "You are already in a call and cannot start another one at the moment" },
	"error-link-to-same-location": { text: "You cannot create a link to the same location" },
	"error-delete-current-scene": { text: "You are trying to delete the scene you're currently in. Select another scene, and then delete this one." },
	"error-enter-scene-name": { text: "Please enter the scene public name" },
	"error-paypal-url": { text: "Invalid paypal URL" },
	"error-chess-instances": { text: "Only one chess game per scene is allowed" },
	"error-provide-title": { text: "Please provide a title" },
	"error-button-url": { text: "Please provide a URL for the button" },
	"error-button-title": { text: "Please provide a title for the button" },
	"error-turn-on-camera": { text: "Please turn on your camera!" },
	"error-waiting-second-player": { text: "Waiting for the second player!" },
	"error-action-stop-screen-share": { text: "This action can be triggerd only by the person who is currently sharing screen" },
	"error-user-dont-exist": { text: "User does not exists" },
	"error-object-could-not-load": { text: "An object could not be loaded ({name}). It may be missing or unsupported." },
	"error-objects-could-not-load": { text: "{count} objects could not be loaded ({names}). They may be missing or unsupported." },
	"error-scene-does-not-exist": { text: "This scene does not exist and could not be opened." },
	"error-clicked-object-does-not-exist": { text: "This object does not exist and could not be opened." },
	"error-invalid-email": { text: "Invalid email address" },
	"error-iframe-url": { text: "Invalid iFrame URL" },
	"error-bagless-room-access": { text: "You cannot go to this room with your current account access level!" },
	"error-max-limit-reached": { text: "Maximum number of elements of this type has been reached" },
	"error-max-locations-reached": { text: "Maximum number of locations has been reached" },
	"error-take-screen": { text: 'Someone was faster than you. The screen is already taken.' },
	"error-already-sharing": { text: 'You are already sharing!' },
	"error-guest-cannot-buy-tickets": { text: 'Guests cannot buy tickets, please log in!' },
	"error-both-dates": { text: 'Both "from" and "until" date inputs must be set!' },
	"error-not-available-intour-mode": { text: 'Not available in tour mode' },
	"error-not-available-while-talking-with-agent": { text: 'Not available while talking with agent' },
	"error-screen-sharing-in-progress": { text: "Someone else is already sharing their screen. Please wait until they finish." },

	"iframe-text": { text: 'iFrame' },
	"online-text": { text: 'Online' },
	"draft-modal-title": { text: 'Draft room' },
	"draft-modal-info-message": { text: "Please provide a name for the room and set it's coordinates" },
	"chess-white": { text: "White" },
	"chess-black": { text: "Black" },
	"chess-made-a-move": { text: "has made a move" },
	"chess-to": { text: "to" },
	"chess-in-your-chessgame": { text: "in your Chessgame" },
	"chess-in-checkmate": { text: "is in checkmate" },
	"chess-in-check": { text: "is in check" },
	"no-more-moves": { text: "No more moves" },
	"chess-restart-text": { text: "Restart" },
	"chess-flip-table-text": { text: "Flip Table" },
	"chess-history-text": { text: "History" },
	"chess-lock-game-text": { text: "Lock Game" },

	"success-entry-point-saved": { text: "Location entry point saved!" },
	"success-added-as-owner": { text: "User added as owner" },
	"success-email-copied": { text: "Email address copied to clipboard!" },
	"success-world-name-copied": { text: "World name copied to clipboard" },

	"info-join": { text: 'joined' },
	"info-enter": { text: 'enters' },
	"info-owner": { text: 'You are the owner' },
	"info-no-elements": { text: 'This scene has currently no elements.' },

	"toolbox-text": { text: 'Toolbox' },
	"new-text": { text: 'Tour mode' },
	"tour-mode-only-text": { text: 'New' },
	"locked-text": { text: 'Locked' },
	"add-chair": { text: 'Add chair' },
	"add-screen-share": { text: 'Add screen share' },
	"add-profile": { text: 'Add profile' },
	"add-image-link": { text: 'Add image/link' },
	"add-scene-change": { text: 'Add scene change' },
	"add-youtube-video": { text: 'Add youtube video' },
	"add-iframe-agent": { text: 'Add iframe' },
	"add-timer-element": { text: 'Add timer' },
	"timer-text": { text: 'Timer' },
	"edit-timer-element": { text: 'Edit timer' },
	"timer-preset-label": { text: 'Time preset (h:m:s)' },
	"event-timer-started": { text: 'Timer started' },
	"event-timer-stopped": { text: 'Timer stopped' },
	"event-timer-ended": { text: 'Timer ended' },
	"action-start-timer": { text: 'Start timer' },
	"action-stop-timer": { text: 'Stop timer' },
	"action-reset-timer": { text: 'Reset timer' },
	"add-vapi-agent": { text: 'Add VAPI Agent' },
	"select-vapi-agent": { text: 'Select AI agent' },
	"no-vapi-agents-in-library": { text: 'No AI agents in library. Create one first.' },
	"add-chess-game": { text: 'Add chess game' },
	"add-bagless-room": { text: 'Add bagless room' },
	"add-info-element": { text: 'Add info element' },
	"add-input-field-guess": { text: 'Add input guess' },
	"input-field-guess": { text: 'Input guess' },
	"edit-input-field-guess": { text: 'Edit input guess' },
	"question-text": { text: 'Question' },
	"correct-answer-text": { text: 'Correct answer' },
	"input-field-guess-title-placeholder": { placeholder: 'Enter title' },
	"input-field-guess-body-placeholder": { placeholder: 'Enter body text' },
	"body-text": { text: 'Body text' },
	"input-field-guess-answer-placeholder": { placeholder: 'Enter correct answer' },
	"input-field-guess-answer-edit-placeholder": { placeholder: 'Leave blank to keep current answer' },
	"input-field-guess-user-answer-placeholder": { placeholder: 'Your answer' },
	"input-field-guess-answer-hint": { text: 'Answer is stored securely on the server, not in scene data.' },
	"input-field-guess-autoclose-true": { text: 'Autoclose on correct answer' },
	"input-field-guess-autoclose-false": { text: 'Autoclose on wrong answer' },
	"event-input-guess-open": { text: 'Open' },
	"event-input-guess-close": { text: 'Close' },
	"event-user-answered-true": { text: 'User answered correctly' },
	"event-user-answered-false": { text: 'User answered incorrectly' },
	"action-input-guess-open": { text: 'Open' },
	"action-input-guess-close": { text: 'Close' },
	"error-provide-question": { text: 'Please provide a question.' },
	"error-provide-correct-answer": { text: 'Please provide the correct answer.' },
	"error-provide-answer": { text: 'Please enter an answer.' },
	"error-check-answer-failed": { text: 'Could not verify your answer. Please try again.' },
	"add-input-field": { text: 'Add input field' },
	"input-field": { text: 'Input field' },
	"edit-input-field": { text: 'Edit input field' },
	"input-field-title-placeholder": { placeholder: 'Enter title' },
	"input-field-body-placeholder": { placeholder: 'Enter body text' },
	"input-field-placeholder-label": { text: 'Placeholder' },
	"input-field-placeholder-placeholder": { placeholder: 'Your answer' },
	"input-field-user-placeholder": { placeholder: 'Your answer' },
	"input-field-key-label": { text: 'Field key' },
	"input-field-key-placeholder": { placeholder: 'email' },
	"input-field-funnel-step-label": { text: 'Funnel step' },
	"input-field-funnel-step-placeholder": { placeholder: 'lead_email' },
	"input-field-validation-label": { text: 'Validation' },
	"input-field-validation-required": { text: 'Required' },
	"input-field-validation-email": { text: 'Email' },
	"input-field-validation-phone": { text: 'Phone' },
	"input-field-validation-min-length": { text: 'Minimum length' },
	"input-field-validation-none": { text: 'None' },
	"input-field-min-length-label": { text: 'Minimum length' },
	"input-field-autoclose": { text: 'Close after submit' },
	"input-field-privacy-hint": { text: 'Answers are stored in Bagless with the Amplitude session ID. Amplitude only receives the funnel step, not the value.' },
	"event-input-field-open": { text: 'Open' },
	"event-input-field-close": { text: 'Close' },
	"event-input-field-submitted": { text: 'Submitted' },
	"event-input-field-validation-failed": { text: 'Validation failed' },
	"action-input-field-open": { text: 'Open' },
	"action-open-input-field": { text: 'Open input field' },
	"action-open-embedded-webpage": { text: 'Open embedded webpage' },
	"connect-event-select-input-field": { text: 'Please select an input field' },
	"action-input-field-close": { text: 'Close' },
	"error-provide-input": { text: 'Please enter a value.' },
	"error-invalid-email": { text: 'Please enter a valid email.' },
	"error-invalid-phone": { text: 'Please enter a valid phone number.' },
	"error-min-length": { text: 'Please enter a longer value.' },
	"error-value-too-long": { text: 'That value is too long.' },
	"error-save-input-failed": { text: 'Could not save your answer. Please try again.' },
	"add-paypal-donation": { text: 'Add PayPal donation' },
	"add-image-gallery": { text: 'Image gallery' },
	"add-product": { text: 'Add product' },
	"add-video": { text: 'Add video (deprecated)' },
	"add-embedded-webpage": { text: 'Add embedded webpage' },
	"add-image-gallery": { text: 'Add image gallery' },
	"expand-toolbox": { text: 'Expand toolbox' },

	"edit-chair": { text: 'Edit chair' },
	"edit-screen-share": { text: 'Edit screen share' },
	"edit-profile": { text: 'Edit profile' },
	"edit-image-link": { text: 'Edit image/link' },
	"edit-scene-change": { text: 'Edit scene change' },
	"edit-youtube-video": { text: 'Edit youtube video' },
	"edit-iframe-agent": { text: 'Edit iframe' },
	"edit-vrai-agent": { text: 'Edit AI Agent' },
	"edit-chess-game": { text: 'Edit chess game' },
	"edit-bagless-room": { text: 'Edit bagless room' },
	"edit-info-element": { text: 'Edit info element' },
	"edit-paypal-donation": { text: 'Edit PayPal donation' },
	"edit-product": { text: 'Edit product' },
	"edit-embedded-webpage": { text: 'Edit embedded webpage' },

	"chair": { text: 'Chair' },
	"screen-share": { text: 'Screen share' },
	"profile": { text: 'Profile' },
	"image-link": { text: 'Image/link' },
	"scene-change": { text: 'Scene change' },
	"youtube-video": { text: 'Youtube video' },
	"chess-game": { text: 'Chess game' },
	"bagless-room": { text: 'Bagless room' },
	"info-element": { text: 'Info element' },
	"video-gallery-element": { text: 'Video element' },
	"paypal-donation": { text: 'PayPal donation' },
	"product": { text: 'Product' },
	"embedded-webpage": { text: 'Embedded webpage' },
	"ai-agents-list": { text: 'AI agents' },
	"ai-tokens-list": { text: 'AI tokens' },
	"add-ai-token": { text: 'Add token' },
	"edit-ai-token": { text: 'Edit AI token' },
	"ai-tokens-help": { text: 'Personalized extra VAPI prompt. Share the token link so the AI loads this visitor’s context.' },
	"ai-tokens-default-link": { text: 'Default link (no token)' },
	"ai-token-name": { text: 'Name' },
	"ai-token-value": { text: 'Token' },
	"ai-token-value-help": { text: 'Used in the share URL as AItoken. Leave empty to auto-generate.' },
	"ai-token-generate": { text: 'Generate' },
	"ai-token-prompt": { text: 'Prompt' },
	"ai-token-prompt-help": { text: 'Sent to VAPI as tokenPrompt when this space is opened with this token. Use {{tokenPrompt}} in the dashboard assistant.' },
	"ai-token-calls": { text: 'calls' },
	"ai-token-copy-link": { text: 'Copy link' },
	"ai-token-viewer-report": { text: 'Report on viewer' },
	"ai-token-required-fields": { text: 'Name and prompt are required' },
	"ai-token-save-failed": { text: 'Failed to save token' },
	"ai-token-delete-confirm": { text: 'Delete this AI token?' },
	"ai-token-delete-failed": { text: 'Failed to delete token' },
	"ai-token-report-empty": { text: 'No viewer calls yet.' },
	"no-ai-tokens-text": { text: 'No AI tokens yet.' },
	"ai-agents-in-space": { text: 'In this space' },
	"ai-agents-your-library": { text: 'Your library' },
	"edit-vapi-library-agent": { text: 'Edit AI agent' },
	"vapi-library-edit-secret-note": { text: 'Paste a private key to replace the saved one. Leave it empty to keep the saved key. Calls use the fast connection.' },
	"vapi-library-key-saved-private": { text: 'A private key is saved. Paste a new one to replace it, or leave this empty.' },
	"vapi-library-key-missing": { text: 'No private key is saved. Paste one so calls can start.' },
	"delete-text": { text: 'Delete' },
	"only-owner-can-delete-agent": { text: 'Only the space owner can delete agents.' },
	"ai-agent-copy": { text: 'Copy' },
	"ai-agent-paste": { text: 'Paste' },
	"ai-agent-config-copied": { text: 'Agent config copied.' },
	"ai-agent-config-pasted": { text: 'Agent config pasted.' },
	"vrai-agent-switch-call-confirm": { text: 'Another agent is on a call. End that call and start this one?' },
	"vrai-agent-switch-stop-process-confirm": { text: 'Switching the AI agent will end the current call/process. Continue?' },
	"no-vrai-agents-text": { text: 'No AI agents in this space.' },
	"vrai-agent-text": { text: 'AI Agent' },
	"vrai-agent-name": { text: 'Agent name' },
	"vrai-agent-scenario": { text: 'Agent scenario' },
	"vrai-agent-scenario-default": { text: 'Voice Assistant' },
	"vrai-agent-components": { text: 'Components' },
	"vrai-agent-chair": { text: 'Avatar / Chair' },
	"vrai-agent-camera": { text: 'User Camera' },
	"vrai-show-user-avatar": { text: 'Show user avatar' },
	"vrai-agent-transcription": { text: 'Transcription' },
	"vrai-agent-vapi-prompt": { text: 'VAPI prompt' },
	"vrai-agent-vapi-prompt-help": { text: 'Added as extra room context for this agent.' },
	"vrai-agent-vapi-prompt-placeholder": { text: 'e.g. This room is the lobby. Greet visitors and answer questions about the space.' },
	"vrai-agent-buttons": { text: 'Command Actions' },
	"vrai-ai-events": { text: 'AI Events' },
	"vrai-ai-event-add": { text: 'Add AI event' },
	"vrai-ai-events-help": { text: 'Events the Room AI can trigger. Connect them to actions in Events/Actions.' },
	"vrai-ai-event-name": { text: 'Event name' },
	"vrai-ai-event-name-placeholder": { text: 'e.g. lookAtChair' },
	"vrai-ai-event-when": { text: 'When to call' },
	"vrai-ai-event-when-placeholder": { text: 'e.g. when the user asks to see the chair' },
	"vrai-ai-event-connect": { text: 'Connect' },
	"vrai-ai-event-name-required": { text: 'Enter an event name (letters, numbers, underscore).' },
	"vrai-ai-event-name-duplicate": { text: 'An AI event with this name already exists.' },
	"vrai-agent-button": { text: 'Command Action' },
	"vrai-agent-button-label": { text: 'Command name' },
	"vrai-agent-button-action": { text: 'Command' },
	"vrai-agent-button-icon": { text: 'Icon' },
	"vrai-agent-button-no-icon": { text: 'No icon' },
	"vapi-command-actions": { text: 'Command Actions' },
	"vapi-command-action": { text: 'Command Action' },
	"vapi-command-action-fallback": { text: 'Command Action' },
	"vapi-command-name": { text: 'Command name' },
	"vapi-command-text": { text: 'Command' },
	"vapi-command-text-placeholder": { text: 'Text to send to VAPI' },
	"transcription-colors": { text: 'Transcription colors' },
	"transcription-color-user": { text: 'Your responses' },
	"transcription-color-user-role": { text: 'Your role label' },
	"transcription-color-ai": { text: 'AI responses' },
	"transcription-color-ai-role": { text: 'AI role label' },
	"transcription-color-bg": { text: 'Background' },
	"vrai-agent-end-call-confirm": { text: 'End call?' },
	"vrai-agent-scene-change-confirm": { text: 'You are still talking with the AI agent. End the call and join the new scene?' },
	"vrai-agent-image": { text: 'Agent image' },
	"vrai-agent-assistant-id": { text: 'VAPI Assistant ID' },
	"vrai-agent-private-key": { text: 'VAPI Private Key' },
	"vrai-agent-key-help": { text: 'Private key. Calls use the fast connection. The key is encrypted and is never shown again.' },
	"vrai-agent-required-fields": { text: 'Assistant ID and a private API key are required' },
	"vrai-agent-request-media": { text: 'Requesting camera & microphone...' },
	"vrai-agent-request-mic": { text: 'Requesting microphone...' },
	"vrai-agent-connecting": { text: 'Connecting...' },
	"vrai-agent-connect-failed": { text: 'Connection failed' },
	"vrai-agent-no-assistant": { text: 'Agent not configured' },
	"vrai-agent-media-failed": { text: 'Camera/mic access required' },
	"vrai-agent-mic-failed": { text: 'Microphone access required' },
	"vrai-agent-talking": { text: 'Agent: Talking' },
	"vrai-agent-thinking": { text: 'Agent: Thinking' },
	"vrai-agent-status-thinking": { text: 'Thinking...' },
	"vrai-agent-status-talking": { text: 'Talking...' },
	"ai-interaction-consent-title": { text: 'AI interaction' },
	"ai-interaction-consent-message": { text: 'You are about to interact with an AI system. Do you want to continue?' },
	"ai-interaction-consent-accept": { text: 'Accept' },
	"ai-interaction-consent-decline": { text: 'Decline' },
	"ai-interaction-active": { text: 'AI is active' },
	"ai-interaction-connecting": { text: 'Connecting to AI' },
	"ai-interaction-listening": { text: 'AI is listening' },
	"ai-interaction-thinking": { text: 'AI is thinking' },
	"ai-interaction-talking": { text: 'AI is talking' },
	"vrai-agent-prompt-transcript-title": { text: 'Send message' },
	"vrai-agent-prompt-transcript-hint": { text: 'Edit the message before sending it to the agent.' },
	"vrai-agent-talk-to-agent-aria": { text: 'Talk to AI' },
	"test-agent-text": { text: 'Test agent' },
	"test-agent-idle": { text: 'Click Start call to talk to this agent' },
	"test-agent-no-agent": { text: 'Add an AI agent first to test this token.' },
	"test-agent-token-label": { text: 'Token' },
	"vrai-agent-transcription-preview-user-line": { text: 'Hello, can you help me?' },
	"vrai-agent-transcription-preview-agent-line": { text: 'Of course! What would you like to know?' },
	"vrai-agent-talk-summary-report-brand": { text: 'myLINA - Integration smart gedacht' },
	"vrai-agent-talk-summary-report-version": { text: 'myLINA Version: MVP2' },
	"vrai-agent-talk-summary-scenario-label": { text: 'Dialog Szenario' },
	"vrai-agent-talk-summary-participant-label": { text: 'Proband' },
	"vrai-agent-talk-summary-transcript-title": { text: 'DIALOG VERLAUF' },
	"vrai-agent-talk-summary-role-user": { text: '[PROBAND]: ' },
	"vrai-agent-talk-summary-role-agent": { text: '[PATIENT ] : ' },
	"drag-text": { text: 'Drag' },
	"remove-text": { text: 'Remove' },
	"vapi-not-initialized": { text: 'VAPI not initialized. Please check your configuration.' },
	"vapi-set-public-key-help": { text: 'A private API key is required. Calls use the fast connection.' },
	"vapi-camera-mic-required": { text: 'Camera and microphone access is required for the call.' },
	"vapi-error-prefix": { text: 'Vapi error' },
	"vapi-error-check-config": { text: 'Check the console and the assistant ID.' },

	"share-location-text": { text: 'Share location' },
	"room-url-placeholder": { placeholder: 'Room URL' },
	"copy-link-value": { value: 'Copy link' },
	"show-interaction-points": { text: 'Show interaction points' },
	"hide-interaction-points": { text: 'Hide interaction points' },

	"add-text": { text: 'Add' },
	"scene-change-target": { text: 'Scene change target' },
	"scene-change-image": { text: 'Scene change image' },
	"upload-thumb-image-title": { title: 'Upload thumbnail image' },
	"target-scene-text": { text: 'Target scene' },
	"change-text": { text: 'Change' },
	"open-link-new-window": { text: 'Open link in new window' },
	"link-url-text": { text: 'Link URL' },
	"link-image-text": { text: 'Link image' },
	"upload-img-title": { title: 'Upload image' },
	"delete-img-title": { title: 'Delete image' },
	"add-products-text": { text: 'Add products' },
	"edit-products-text": { text: 'Edit products' },
	"add-up-to-products": { text: 'Add up to 10 products' },
	"product-name-text": { text: 'Product name' },
	"required-text": { text: '(Required)' },
	"product-name-input": { value: 'Product name', placeholder: 'Product name' },
	"product-image-text": { text: 'Product image' },
	"upload-product-image-title": { title: 'Upload product image' },
	"delete-product-image-title": { title: 'Delete product image' },
	"best-img-resolution-product": { text: 'Best resolution 800x400' },
	"product-desc-text": { text: 'Product description' },
	"product-desc-placeholder": { placeholder: 'Product description' },
	"price-text": { text: 'Price' },
	"price-placeholder": { text: 'Price' },
	"product-url-text": { text: 'Product URL' },
	"button-label-text": { text: 'Button label' },
	"shop-button-placeholder": { placeholder: 'BUY ITEM' },
	"add-more-text": { text: 'Add more' },
	"save-changes-text": { text: 'Save changes' },
	"who-can-stream-notification": { text: 'Who can stream on this screen?' },
	"everyone-text": { text: 'Everyone' },
	"owner-text": { text: 'Owner' },
	"on-request-text": { text: 'On request' },
	"choose-your-layout": { text: 'Choose your layout' },
	"cover-image-text": { text: 'Cover image' },
	"title-text": { text: 'Title' },
	"description-text": { text: 'Description' },
	"desc1-text": { text: 'Description 1' },
	"desc2-text": { text: 'Description 2' },
	"button-text": { text: 'Button' },
	"simple-text": { text: 'Simple' },
	"image-text": { text: 'Image' },
	"complex-text": { text: 'Complex' },
	"next-text": { text: 'Next' },
	"info-element-placeholder": { placeholder: 'Info element' },
	"upload-info-element-title": { title: 'Upload info element image' },
	"title-placeholder": { placeholder: 'Title' },
	"info-drag-and-drop-img": { text: 'Drag and drop image to this area to upload' },
	"info-drag-and-drop-video": { text: 'Drag and drop video to this area to upload' },
	"supported-files-text": { text: 'Supported files' },
	"edit-info-element": { text: 'Edit info element' },
	"edit-image-gallery-element": { text: 'Edit image gallery element' },
	"edit-video-gallery-element": { text: 'Edit video gallery element' },
	"url-or-id": { text: 'URL or ID' },
	"dynamic-avatar-img": { text: 'Dynamic avatar image' },
	"always-latest-avatar": { text: 'Always use my latest avatar image on this object' },
	"profile-avatar-text": { text: 'Profile avatar' },
	"upload-profile-img-title": { title: 'Upload profile image' },
	"delete-profile-img-title": { title: 'Delete profile image' },
	"confirm-dialog-text": { text: 'Confirmation dialog' },
	"connect-to-bagless-room": { text: 'Connect to bagless room' },
	"choose-target-room": { text: 'Choose target room' },
	"select-scene-text": { text: 'Select scene' },
	"additional-help-visit": { text: 'For additional help, visit' },
	"donation-img-title": { title: 'Donation image' },
	"donation-image": { title: 'Donation image', text: 'Donation image' },
	"delete-video-title": { title: 'Delete video' },
	"upload-welcome-screen-video-title": { title: 'Upload welcome screen video' },
	"video-text": { text: 'Video' },
	"upload-video-text": { text: 'Upload video' },
	"upload-video-title": { title: 'Upload video' },
	"welcome-screen-editor": { text: 'Welcome screen editor' },

	"iframe-text": { text: 'iFrame' },
	"online-text": { text: 'Online' },
	"paid-location-text": { text: "Paid location" },
	"paid-location-tooltip": { text: "Access is granted based on payment" },
	"payment-setup-title": { text: 'Location payment setup' },
	"duration-text": { text: 'Duration' },
	"until-text": { text: 'until' },
	"from-date-title": { title: 'From date' },
	"until-date-title": { title: 'Until date' },
	"or-text": { text: 'or' },
	"days-text": { text: 'days' },
	"email-text": { text: 'Email' },
	"location-desc-text": { text: 'Location description' },

	"user-profile-text": { text: 'User profile' },
	"user-profile-text-saved": { text: 'User profile saved' },
	"minimize-text": { text: 'Minimize' },
	"flip-board-text": { text: 'Flip board' },
	"restart-text": { text: 'Restart' },
	"quit-game-text": { text: 'Quit game' },
	"game-status-text": { text: 'Game status' },
	"quit-text": { text: 'Quit' },
	"join-public-stage": { text: "You are about to enter a public location. This means that you will receive audio and aideo streams of other people regardless of your own state." },
	"welcome-aboard": { text: 'Welcome aboard!' },
	"start-exploring": { text: 'Start exploring' },
	"crop-image": { text: 'Crop image' },
	"landscape-aspect": { text: 'Landscape (16:9)' },
	"portrait-aspect": { text: 'Portrait (9:16)' },
	"choosen-avatar": { text: 'Chosen avatar' },
	"please-select-avatar": { text: 'Please select your avatar image.' },
	"restricted-access-text": { text: 'Restricted access' },
	"help-text": { text: 'Help' },
	"select-stream-source": { text: 'Select stream source' },
	"start-streaming-value": { value: 'Start streaming' },
	"screen": { text: 'Screen' },
	"offline-message-sent": { text: 'Notification sent' },
	"success-contributore": { text: 'Contributore added' },
	"filters-text": { text: 'Filters' },
	"update-profile": { text: 'Update profile' },
	"go-back-text": { text: 'Go back' },
	"embed-room-text": { text: 'Copy' },
	"link-copied": { text: 'Copied to clipboard' },
	"private-rooms-available": { text: 'Private rooms will be available to logged-in users only' },
	"error-user-data-not-found": { text: 'Error loading user data' },
	"guest-modal-why-should-i-login": { text: 'Why should I log in?' },
	"guest-modal-features": { text: 'For more features and functions you may' },
	"autoplay": { text: 'Autoplay' },
	"custom-icon-text": { text: 'Custom Icon' },
	"request-permission-text": { text: 'Request permission for camera an microphone' },
	"request-permission-you-must-text": { text: 'You need to enable permissions to use all features.' },
	"user-cancelled-share-text": { text: 'Screen sharing was canceled' },
	"support-ticket-text": { text: 'Create Support Ticket' },
	"no-empty-seat-text": { text: 'No empty seats available' },
	"empty-seat-reminder-text": { text: 'Empty seat reminder' },

	"back-to-home": { text: 'Back to home' },
	"approve-text": { text: 'Approves' },
	"reject-text": { text: 'Reject' },
	"ok-text": { text: 'OK' },
	"session-locked-title": { text: 'Session locked' },
	"session-locked-message": { text: "You have locked the room. Other users can't edit the room until you release the lock or after 30 minutes of inactivity." },
	"session-unlocked-title": { text: 'Session unlocked' },
	"session-unlocked-message": { text: "You have unlocked the room. Other users can request to take over the session." },
	"session-locked-by-title": { text: 'Session locked' },
	"session-locked-by-message": { text: "This room is edited by <strong>{userName}</strong>, but the session is locked.<br /> Please contact <strong>{userName}</strong> to release the lock." },
	"session-in-progress-title": { text: 'Session in progress by another user' },
	"session-in-progress-message": { text: "This room is already edited by <strong>{userName}</strong>.<br />Do you want to take over the session?" },
	"takeover-button": { text: 'Takeover' },
	"takeover-request-title": { text: 'Takeover request' },
	"takeover-request-message": { text: "<strong>{userName}</strong> has requested to take over the session.<br />Be aware that you will lose your changes if you approve the request.<br />Do you want to approve the request?" },
	"takeover-pending-title": { text: 'Session takeover pending' },
	"takeover-pending-message": { text: "Waiting for <strong>{userName}</strong> to approve the session takeover.<br />If there is no action from <strong>{userName}</strong>, it will be unlocked automatically in {countdown}." },
	"takeover-approved-title": { text: 'Session takeover approved' },
	"takeover-approved-message": { text: "<strong>{userName}</strong> has approved the session takeover. You can now edit the room." },
	"takeover-rejected-title": { text: 'Session takeover rejected' },
	"takeover-rejected-message": { text: "<strong>{userName}</strong> has rejected the session takeover. Please contact <strong>{userName}</strong> to release the lock." },
	"takeover-approved-by-message": { text: "You have approved the session takeover. <strong>{userName}</strong> can now edit the room." },
	"takeover-cancelled-title": { text: 'Session takeover cancelled' },
	"deactivate-session-lock-message": { text: "Are you still there? We are going to log you out in {countdown}." },
	"activate-session-lock-message": { text: "You are set to inactive. Do you want to activate again?" },
	"auto-take-seat-text": { text: 'Auto take seat link' },
	"landscape-text": { text: 'Please rotate your device to landscape mode' },
	"location-menu-text": { text: 'Location menu' },
	"location-menu-jump-to": { text: 'Jump to location' },
	"location-menu-navigation-title": { text: 'Navigation' },
	"chats": { text: 'Chats' },
	"current-room": { text: 'Room chat' },
	"latest-chats": { text: 'Latest chats' },
	"not-found-selected-device": { text: 'Selected device not found' },
	"socket-connection-lost": { text: 'Connection to Bagless server lost' },
	"socket-reconnected": { text: 'Reconnected to Bagless server' },
	"socket-reconnecting": { text: 'Reconnecting to Bagless server' },
	"network-connection-lost": { text: 'No internet connection' },
	"network-poor-connection": { text: 'Poor internet connection' },
	"reconnect": { text: 'Reconnect' },
	"device-select-join-with-media": { text: 'Join with audio and video' },
	"device-select-join-as-viewer": { text: 'Join as a viewer only' },
	"device-select-join": { text: 'Join' },
	"device-select-cancel": { text: 'Cancel' },
	"exit-app-confirm": { text: 'Are you sure you want to exit?' },
	"no-empty-screen-share-seats": { text: 'No empty screen share seats found' },
	"error-please-take-seat": { text: 'Please take a seat first' },
	"leave-game-or-standup": { text: 'Leave game or standup ?' },
	"standup-text": { text: 'Standup' },
	"leave-game-text": { text: 'Leave game' },
	"chess-game-locked": { text: 'The Game is locked by a Player, you cannot enter now, please wait until the game has ended.' },
	"enter-chess-but-you-are-sitting": { text: 'Entering chess game will stand you up from your current seat, do you want to continue?' },
	"confirm-end-one-on-one-to-continue": { text: 'This will end your 1:1 call. Do you want to continue?' },
	"end-call-and-continue": { text: 'End call and continue' },
	"empty-seat-reminder-text": { text: 'Enable empty seat reminder?' },
	"confirm-title-leave-seat": { text: 'Leave seat' },
	"user-declines-your-request-to-take-a-seat": { text: 'User declines your request to take a seat.' },
	"is-inviting-you-to-take-seat": { text: 'is inviting you to take seat' },
	"would-you-like-to-take-a-seat-or-invite-guest": { text: 'Would you like to take a seat or invite guest?' },
	"start-tour-title": { text: 'Start a tour' },
	"start-tour-btn": { text: 'Start your tour' },
	"start-tour-name-placeholder": { placeholder: 'Give your tour a name' },
	"start-tour-visibility-public": { text: 'Public' },
	"start-tour-visibility-private": { text: 'Private' },
	"start-tour-visibility-public-desc": { text: 'Everybody is invited to join.' },
	"start-tour-visibility-private-desc": { text: 'Only by request by the guide.' },
	"start-tour-one-to-one": { text: '1:1 tour' },
	"start-one-on-one-tour-text": { text: 'Start One-on-One Tour' },
	"start-one-on-one-user-offline": { text: 'This person is not online.' },
	"start-one-on-one-unavailable": { text: 'You can’t start a tour in this space.' },
	"one-to-one-tour-closed": { text: 'This is a private 1:1 tour' },
	"one-to-one-tour-seat-taken": { text: 'This 1:1 tour already has a guest' },
	"start-tour-default-name": { text: "{userName}'s tour" },
	"end-tour-confirm": { text: 'The tour will end for everyone, and all activities will be stopped.' },
	"end-tour-confirm-title": { "text": "End tour" },
	"end-tour-confirm-btn": { text: 'End tour' },
	"exit-tour-confirm": { text: 'Are you sure you want exit tour?' },
	"exit-tour-confirm-btn": { text: 'Exit' },
	"exit-tour-choice": { text: 'Do you want to guest list or exit Tour' },
	"exit-tour-choice-guest": { text: 'Guest list' },
	"exit-tour-choice-exit": { text: 'Exit Tour' },
	"exit-tour": { text: 'Exit tour' },
	"exit-podium": { text: 'Exit podium' },
	"exit-podium-confirm": { text: 'Leave the podium? You will stay in the tour as a guest.' },
	"exit-podium-confirm-btn": { text: 'Exit podium' },
	"error-call-already-in-progress": { text: 'Error: Call already in progress' },
	"restart-game-confirm": { text: 'Are you sure you want to restart the game?' },
	"is-inviting-you-to-join-room": { text: 'is inviting you to join room' },
	"exit-game-confirm": { text: 'Are you sure you want to leave the game?' },
	"language-menu-title": "Language",
	"language-menu-english": "English",
	"language-menu-german": "German",
	"language-menu-romanian": "Romanian",
	"spaces-header-title": { text: 'Bagless through the world. Find your tour, your space, your friends' },
	"spaces-online-friends-title": { text: 'Friends' },
	"spaces-friends-offline": { text: 'Offline' },
	"spaces-online-friends-loading": { text: 'Loading friends...' },
	"spaces-online-friends-empty": { text: 'No friends online' },
	"spaces-online-friends-none": { text: 'You have no friends yet' },
	"spaces-online-friends-error": { text: 'Could not load friends' },
	"spaces-search-placeholder": { placeholder: 'Where or what are you looking for?' },
	"spaces-create-new": { text: 'Create New Space' },
	"spaces-order-by": { text: 'Order by' },
	"spaces-sort-by": { text: 'Sort by' },
	"spaces-creation-date": { text: 'Creation date' },
	"spaces-update-date": { text: 'Update date' },
	"spaces-space-name": { text: 'Space name' },
	"spaces-active-users": { text: 'Active users' },
	"spaces-number-of-visitors": { text: 'Number of visitors' },
	"spaces-distance": { text: 'Distance' },
	"spaces-sort": { text: 'Sort' },
	"spaces-filter": { text: 'Filter:' },
	"spaces-space-language": { text: 'Space Language' },
	"spaces-all-spacetags": { text: 'All Spacetags' },
	"spaces-enter-scene": { text: 'Enter Space' },
	"spaces-updated": { text: 'Updated:' },

	"user-profile-title": { text: 'Bagless profile' },
	"user-status-online": { text: 'Online' },
	"user-location-label": { text: 'Location:' },
	"user-title-label": { text: 'Title:' },
	"user-company-label": { text: 'Company:' },
	"user-website-label": { text: 'Website:' },
	"user-birthday-label": { text: 'Birthday:' },
	"user-interests-label": { text: 'Interests:' },
	"spaces-heading": { text: 'Spaces' },
	"error-heading": { text: 'Error!' },
	"space-language-label": { text: 'Space language' },
	"location-distance-label": { text: 'Location distance' },
	"clear-button": { text: 'Clear' },
	"apply-button": { text: 'Apply' },

	"administration-text": { text: 'Administration' },
	"admin-spaces-management": { text: 'Spaces Management' },
	"admin-users-management": { text: 'Users Management' },
	"admin-roles-management": { text: 'Roles Management' },
	"admin-plans-management": { text: 'Plans Management' },
	"admin-self-check": { text: 'Self Check' },
	"admin-portal-settings": { text: 'Portal settings' },
	"admin-vapi-agents": { text: 'VAPI agents' },
	"admin-vapi-conversations": { text: 'VAPI conversations' },
	"maintenance-title": { text: 'Under maintenance' },
	"maintenance-description": { text: 'We are currently updating the portal. Please check back soon.' },
	"maintenance-countdown-label": { text: 'Estimated time remaining' },
	"maintenance-reload": { text: 'Reload page' },
	"maintenance-admin-login": { text: 'Admin login' },
	"maintenance-admin-login-hint": { text: 'Administrator login only' },
	"help-center-text": { text: 'Help Center' },
	"report-bug-text": { text: 'Help Center' },

	"footer-bagless-text": { text: 'Bagless' },
	"footer-impressum-text": { text: 'Impressum' },
	"footer-privacy-text": { text: 'Privacy Policy' },
	"footer-terms-text": { text: 'Terms of Use' },
	"footer-cookie-text": { text: 'Cookie Policy' },

	"register-title": { text: 'Register new account' },
	"login-title": { text: 'Login' },
	"email-sent-title": { text: 'Email sent' },
	"resend-confirmation-title": { text: 'Resend confirmation email' },
	"forgot-password-title": { text: 'Forgot password' },
	"reset-password-title": { text: 'Reset password' },

	"password-requirements": { text: 'Password must include uppercase, lowercase, number, and special character (6-72 chars).' },
	"terms-acceptance": { text: 'By registration you are accepting' },
	"terms-and-privacy": { text: 'Terms and Conditions and Privacy Policy' },
	"register-button": { text: 'Register new account' },
	"login-button": { text: 'Log in' },
	"login-link": { text: 'Log in' },
	"register-link": { text: 'Register account' },
	"remember-me": { text: 'Remember for next time' },
	"magic-link-button": { text: 'Get login link' },
	"forgot-password-link": { text: 'Forgot Password?' },
	"register-google": { text: 'Register with Google' },
	"login-google": { text: 'Log in with Google' },
	"already-registered-text": { text: 'Already registered?' },
	"dont-have-account-yet": { text: "Don't have an account yet?" },

	"verify-email-note": { text: 'Please check your email for further instruction on how to verify your account' },
	"magic-link-note": { text: 'Please check your inbox and click the link to log in.' },
	"reset-password-note": { text: 'Please check your email for further instruction on how to reset your password' },
	"resend-confirmation-note": { text: 'If you didn\'t receive the confirmation email, you can request a new one by entering your email address below.' },
	"forgot-password-note": { text: 'Please fill out your email. A link to reset password will be sent there.' },
	"reset-password-enter-note": { text: 'Please enter your new password below.' },

	"resend-button": { text: 'Resend' },
	"send-button": { text: 'Send' },
	"reset-password-button": { text: 'Reset Password' },
	"back-to-login": { text: 'Back to login' },
	// Admin section
	"admin-bulk-delete": { text: 'Bulk Delete' },
	"admin-bulk-edit-roles": { text: 'Bulk Edit Roles' },
	"admin-bulk-update-privacy": { text: 'Bulk Update Privacy' },
	"admin-create-new-user": { text: 'Create new User' },
	"admin-create-new-plan": { text: 'Create new Plan' },
	"admin-create-new-world": { text: 'Create new World' },
	"admin-create-new-world-draft": { text: 'Create new World draft' },
	"admin-create-new-role": { text: 'Create New Role' },
	"admin-create-new-feature": { text: 'Create new Feature' },
	"admin-add-new-permission": { text: 'Add New Permission' },
	"admin-search-button": { text: 'Search' },
	"admin-search-placeholder": { placeholder: 'Search...' },
	"admin-plans-tab": { text: 'Plans' },
	"admin-features-tab": { text: 'Features' },
	"admin-roles-tab": { text: 'Roles' },
	"admin-permissions-tab": { text: 'Permissions' },
	"this-space": { text: "This Space" },
	"space-contributors-text": { text: "Space contributors" },
	"admin-space-type": { text: 'Space Type' },
	"admin-space-type-public": { text: 'Public' },
	"admin-space-type-premium": { text: 'Premium' },

	"email-change-title": { text: 'Change Email' },
	"email-change-note": { text: 'Enter your new email address and current password to change your email.' },
	"email-change-button": { text: 'Change Email' },
	"email-change-email-note": { text: 'Please check your email for a verification link to complete the email change process.' },

	"password-change-title": { text: 'Change Password' },
	"password-change-note": { text: 'Enter your current password and a new password to update your account security.' },
	"password-change-button": { text: 'Change Password' },
	"password-changed-title": { text: 'Password Changed' },
	"password-changed-note": { text: 'Your password has been successfully updated.' },
	"password-set-title": { text: 'Set Password' },
	"password-set-note": { text: 'Create a password to enable email/password authentication for your account.' },
	"password-set-button": { text: 'Set Password' },
	"support-text": { text: "Support" },
	"updates-and-releases-text": { text: "Updates and releases" },
	"admin-users-active": { text: "Activated" },
	"admin-users-inactive": { text: "Inactive" },
	"exit-chess-game": { text: "This will end chess session" },
	"error-not-available-in-current-plan": { text: "This action is not available on your current plan. Please upgrade to access this feature." },
	"error-not-available-in-guest-plan": { text: "Please log in to access this feature" },
	"not-available-in-free-plan": { text: "This feature is not available in the free plan" },
	"draft-mode-name-text": { text: "Draft mode" },
	"disable-guest-restrictions-name-text": { text: "Disable guest restrictions" },
	"cancel-subscription-title": { text: "Cancel subscription" },
	"cancel-subscription-warning": { text: "Are you sure you want to cancel your subscription? Your subscription will remain active until the end of your current billing period. No refund will be issued." },
	"cancel-subscription-note": { text: "After cancellation, your subscription will continue until the end of the current billing cycle." },
	"cancel-subscription-confirm": { text: "Yes, Cancel My Subscription" },
	"cancel-subscription-cancel": { text: "No, Keep My Subscription" },
	"premium-space-text": { text: "Premium space" },
	"tune-menu-space-settings": { text: "Space Settings" },
	"show-space-info": { text: "Show space info" },
	"space-info-title": { text: "Space info" },
	"space-name-label": { text: "Space name:" },
	"space-description-label": { text: "Description:" },
	"space-type-label": { text: "Type:" },
	"space-visitors-label": { text: "Current visitors:" },
	"already-friends-text": { text: "Already friends" },
	"add-as-friend-text": { text: "Add as friend" },
	"space-select-auth-required": { text: "You need to log in first to create a new Space" },
	"space-select-differences-question": { text: "What is the difference between Public and premium Spaces?" },
	"space-select-type-select-question": { text: "What type of Space do you want to create?" },
	"space-select-upgrade-required": { text: "You need to upgrade to Create a Premium Space" },
	"space-select-out-of-quota": { text: "You don't have any Premium Spaces left" },
	"public-space-text": { text: "Public Space" },
	"premium-space-text": { text: "Premium Space" },
	"go-to-subscription-page": { text: "Go to Subscription Page" },
	"about-bagless": { text: "About" },
	"subscription-status-active": { "text": "Active" },
	"subscription-status-trialing": { "text": "In Trial" },
	"subscription-status-canceled": { "text": "Canceled" },
	"subscription-status-incomplete": { "text": "Incomplete" },
	"subscription-status-incomplete_expired": { "text": "Incomplete Expired" },
	"subscription-status-past_due": { "text": "Past Due" },
	"subscription-status-unpaid": { "text": "Unpaid" },
	"subscription-status-paused": { "text": "Paused" },
	"subscription-interval-day-display": { "text": "daily Payment" },
	"subscription-interval-week-display": { "text": "weekly Payment" },
	"subscription-interval-month-display": { "text": "monthly Payment" },
	"subscription-interval-year-display": { "text": "yearly Payment" },
	"subscription-upgrade-confirmation-text": { "text": "Are you sure you want to upgrade your subscription plan?" },
	"subscription-downgrade-confirmation-text": { "text": "Are you sure you want to downgrade your subscription plan?" },
	"notification-setting-coming-soon": { text: "You will find Notification Settings here soon." },
	"planned-guided-tour-coming-soon": { text: "You will find your planned Guided Tours here soon." },
	"room-free-text": { text: "My Free Spaces" },
	"room-premium-text": { text: "My Premium Spaces" },
	"take_this_seat_to_play_as_black": { text: "Take this seat to play as Black" },
	"take_this_seat_to_play_as_white": { text: "Take this seat to play as White" },
	"take_a_seat_to_talk_with_others": { text: "Take a seat to talk with others" },
	"make-space-premium-question": { text: "Do you really want to make this Space Premium?" },
	"make-space-public-question": { text: "Do you really want to make this Space Public? You will miss some features!" },
	"not-invited-to-private-tour": { text: "This tour is private, you need to be invited to join." },
	// BuyMoreSpacesModal translations
	"manage-premium-spaces-title": { text: "Manage Additional Premium Spaces" },
	"manage-premium-spaces-desc": { text: "Use the slider to adjust your additional premium spaces. Move right to buy more, left to downgrade and receive credit." },
	"current-spaces-text": { text: "Current spaces:" },
	"number-of-spaces-text": { text: "Target number of spaces:" },
	"price-per-space-text": { text: "Price per space:" },
	"total-cost-text": { text: "Total cost:" },
	"total-credit-text": { text: "Total credit:" },
	"cancel-button-text": { text: "Cancel" },
	"proceed-checkout-text": { text: "Proceed to Checkout" },
	"processing-text": { text: "Processing..." },
	"confirm-buy-spaces-title": { text: "Confirm Purchase" },
	"confirm-buy-spaces-message": { text: "Are you sure you want to purchase {quantity} additional premium {spaces} for {amount}?" },
	"confirm-downgrade-spaces-title": { text: "Confirm Downgrade" },
	"confirm-downgrade-spaces-message": { text: "Are you sure you want to downgrade {quantity} premium {spaces}? You will receive a credit of {amount}." },
	"space-singular": { text: "space" },
	"space-plural": { text: "spaces" },

	// Subscription page translations
	"your-subscription-title": { text: "Your Subscription" },
	"user-subscription-title": { text: "User subscription" },
	"cancelled-on-text": { text: "Will be canceled on" },
	"renews-on-text": { text: "Renews on" },
	"current-plan-text": { text: "Current plan" },
	"manage-subscription-button": { text: "Manage Subscription" },
	"premium-spaces-title": { text: "Premium Spaces" },
	"premium-space-included-plan": { text: "Premium Space included from Plan" },
	"additional-premium-space": { text: "Additional Premium Space" },
	"manage-additional-spaces-button": { text: "Manage Additional Premium Spaces" },
	"free-plan-text": { text: "Free Plan" },
	"free-text": { text: "Free" },
	"upgrade-plan-to-manage-spaces-button": { title: "Please upgrade your plan to manage premium spaces.", text: "Manage Additional Premium Spaces" },
	"upgrade-plan-to-manage-spaces-text": { text: "Please upgrade your plan to manage premium spaces" },
	"account-credit-title": { text: "Account Credit" },
	"available-credit-text": { text: "Available credit for future invoices" },
	"credit-text": { text: "Credit" },
	"balance-text": { text: "Balance" },
	"show-plan-comparison": { text: "Show me the Plan Comparison page" },
	"no-active-subscription": { text: "No Active Subscription" },
	"subscribe-access-premium": { text: "Subscribe to a plan to access premium features" },
	"subscribe-now-button": { text: "Subscribe Now" },
	"invoices-title": { text: "Invoices" },
	"issue-date-header": { text: "Issue date" },
	"description-header": { text: "Description" },
	"price-header": { text: "Price" },
	"status-header": { text: "Status" },
	"no-payment-info": { text: "No payment information" },
	"error-invite-to-tour-text": { text: "Only guides can invite users to tours," },
	"user-in-tour-error-text": { text: "User is already in a tour" },
	"private-tour-text": { text: "Private tour" },
	"private-tour-upgrade-text": { text: "Upgrade" },
	"you-must-be-invited-to-join-private-tour": { text: "You must be invited to join a private tour" },

	"plan-update-upgrade-confirmation-title": { text: "Upgrade Confirmation" },
	"plan-update-downgrade-confirmation-title": { text: "Downgrade Confirmation" },
	"plan-update-items-text": { text: "Items" },
	"plan-update-period-text": { text: "Period" },
	"plan-update-qty-text": { text: "Qty" },
	"plan-update-amount-text": { text: "Amount" },
	"plan-update-trial-period-text": { text: "Trial period for" },
	"plan-update-estimation-note": { text: "This is an estimated amount. Final charge may vary by a few cents due to Stripe's proration and rounding rules." },
	"plan-update-payment-note": { text: " After you confirm, Stripe will immediately charge this amount to your saved payment method." },
	"plan-update-credit-note": { text: " After you confirm, no payment will be charged. Any remaining credit will be added to your balance and applied to your future invoices." },
	"plan-update-confirm-upgrade-text": { text: "Confirm Upgrade" },
	"plan-update-confirm-downgrade-text": { text: "Confirm Downgrade" },
	"plan-update-new-plan-text": { text: "New Plan" },
	"plan-update-unused-time-text": { text: "Unused time on" },
	"plan-update-after-text": { text: "after" },
	"plan-update-applied-balance-text": { text: "Applied balance" },
	"plan-update-estimated-total-due-text": { text: "Estimated Total Due" },
	"plan-update-estimated-credit-text": { text: "Estimated Credit Applied to Balance" },
	"space-author-label": { text: "Author:" },
	"space-info-text": { text: "Space info" },
	"invited-text": { text: "(Invited)" },
	"guided-tours": { text: "Guided tours" },
	"guided-tours-running": { text: "Guided Tours running ({count})" },
	"click-to-join": { text: "Click to join" },
	"click-to-load": { text: "Click to load" },
	"saving-changes": { text: "Saving changes" },
	"changes-saved": { text: "Changes saved successfully" },
	"error-saving-changes": { text: "Error saving changes" },
	"advertisement-links-text": { text: "Advertisment - contains affiliate links" },
	"unlimited-text": { text: "Unlimited" },
	"editor-text": { text: "Editor" },
	"error-you-cannot-add-yourself-as-owner": { text: "You cannot add yourself as owner" },
	"you-are-already-contributor": { text: "You are already a contributor" },
	"tour-invitation-sent-text": { text: "Tour invitation sent" },
	"confirm-delete-postit": { text: "Are you sure you want to delete this postit?" },
	"add-postit": { text: "Add post it" },
	"postit-created": { text: "Postit created successfully" },
	"postit-deleted": { text: "Postit deleted successfully" },
	"not-allowed-to-create-postit": { text: "You are not allowed to create postits" },
	"error-404-title": { text: "Page Not Found" },
	"error-404-alt": { alt: "Page Not Found" },
	"error-404-text": { text: "Oops! The page you're looking for doesn't exist." },
	"error-403-title": { text: "Access Forbidden" },
	"error-403-alt": { alt: "Access Forbidden" },
	"error-403-text": { text: "Sorry, you are not authorized to access this page." },
	"go-to-space-browser-text": { text: "Bring me to the Space Browser" },
	"only-creator-can-update-postit": { text: "Only the creator can update this postit" },
	"error-cannot-jump-to-your-own-scene": { text: "You are in the same scene as the user" },
	"chess-game-invitation-sent-text": { text: "Chess game invitation sent" },
	"user-in-activity-error-text": { text: "User is already in an activity" },
	"invite-to-chess-game-text": { text: "Invite to Chess Game" },
	"error-requested-user-action": { text: "User not allowed to perform this action" },
	"invite-text": { text: "Invite" },
	"switch-sides-or-invite": { text: "Switch sides or invite?" },
	"take-seat-as-player-white": { text: "Take seat as player (White)?" },
	"take-seat-as-player-black": { text: "Take seat as player (Black)?" },
	"switch-sides-text": { text: "Switch sides" },
	"is-inviting-you-to-join-chess": { text: "is inviting you to join chess" },
	"leave-game-and-take-seat-as-visitor-or-invite": { text: "Leave game and take seat as visitor or invite?" },
	"user-in-activity-error-text-message": { text: "User is already in an activity, send as message?" },
	"send-as-message-text": { text: "Send as message" },
	"edit-video-player-element-text": { text: 'Edit video player element' },
	"upload-thumbnail-image-text": { text: 'Upload thumbnail image' },
	"video-player-image-text": { text: 'Video player image' },
	"video-title-text": { text: 'Video Title' },
	"add-video-player-text": { text: 'Add video player' },
	"add-video-background-text": { text: 'Add Video Background' },
	"edit-video-background-text": { text: 'Edit Video Background' },
	"add-vr-invisible-action": { text: "Add VR invisible action" },
	"vr-invisible-action": { text: "VR Invisible Action" },
	"edit-vr-invisible-action": { text: "Edit VR Invisible Action" },
	"add-vr-music-object": { text: "Add VR music object" },
	"vr-music-object": { text: "VR Music Object" },
	"edit-vr-music-object": { text: "Edit VR Music Object" },
	"mp3-audio-text": { text: "MP3 audio" },
	"no-audio-uploaded-yet": { text: "No audio uploaded yet" },
	"enter-optional-title-placeholder": { placeholder: 'Enter optional title' },
	"video-file-text": { text: 'Video file' },
	"no-video-selected-text": { text: 'No video selected' },
	"dimensions-text": { text: 'Dimensions' },
	"play-text": { text: 'Play' },
	"use-icon-text": { text: 'Use Icon' },
	"place-as-3d-element-text": { text: 'Place as 3D element' },
	"play-on-click-text": { text: 'Play on click' },
	"video-3d-placeholder-info-text": { text: 'Upload a placeholder image, or the first video frame is used if none is uploaded.' },
	"video-player-placeholder-image-text": { text: 'Placeholder image' },
	"video-transparent-background-text": { text: 'Transparent background' },
	"video-transparent-background-info-text": { text: 'Enable for WebM videos with an alpha channel so the background stays transparent on the 3D mesh.' },
	"default-video-icon-text": { text: 'Default Video Icon' },
	"default-link-icon-text": { text: 'Default Link Icon' },
	"default-gallery-icon-text": { text: 'Default Gallery Icon' },
	"gallery-preview-image-text": { text: 'Preview image' },
	"next-image-duration-text": { text: 'Next image duration (seconds)' },
	"gallery-uploading-text": { text: 'Uploading…' },
	"gallery-upload-failed": { text: 'Upload failed.' },
	"gallery-upload-file-too-big": { text: 'This file is too large.' },
	"gallery-upload-unsupported-file": { text: 'This file type is not supported. Use JPG, PNG, or WebP.' },
	"gallery-upload-dismiss-title": { text: 'Dismiss' },
	"gallery-rotate-left-title": { title: 'Rotate left' },
	"gallery-rotate-right-title": { title: 'Rotate right' },
	"confirm-delete-gallery-image": { text: 'Are you sure you want to delete this image?' },
	"gallery-previous-image": { text: 'Previous image' },
	"gallery-next-image": { text: 'Next image' },
	"gallery-close": { text: 'Close gallery' },
	"gallery-image-loading-text": { text: 'Loading…' },
	"gallery-at-least-one-image": { text: 'At least one image is required to publish.' },
	"no-video-uploaded-yet": { text: 'No video has been uploaded yet' },
	"error-screen-share-limited": { text: "Your screenshare is limited to" },
	"error-screen-share-upgrade-text": { text: "Upgrade to unlock unlimited access and explore without time limits!" },
	'minutes': { text: "minutes" },
	"error-not-logged-in": { text: "Only logged in users can use this feature" },
	"you-need-to-login-to-take-a-seat": { text: "You need to login to take a seat in FREE spaces" },
	"you-need-to-login-to-run-guided-tours": { text: "You need to login to run guided tours" },
	"you-need-to-login-to-create-postit": { text: "You need to login to create postits" },
	"you-need-to-login-to-use-screen-share": { text: "You need to login to use screen share" },
	"info-waiting-for-screen-share": { text: "Waiting for screen share" },
	"info-waiting-for-screen-share-users": { text: "Waiting for screen share users" },
	"info-screen-share-started-users": { text: "Screen share started for users" },
};
